export default __webpack_public_path__ + "static/media/Icons_face_copia.c8e353b4.svg";